<template>
  <b-skeleton-wrapper :loading="loading">
    <template v-slot:loading>
      <div
        v-for="optionItem in optionItems"
        :key="uniqueId('base-checklist-skeleton-item')"
        class="mb-1 d-flex align-items-center"
      >
        <b-skeleton
          width="22px"
          height="22px"
          animation="fade"
          class="mr-2"
        ></b-skeleton>

        <b-skeleton
          :width="`${optionItem}%`"
          height="22px"
          animation="fade"
        ></b-skeleton>
      </div>
    </template>

    <slot />
  </b-skeleton-wrapper>
</template>

<script>
import { defineComponent, computed, inject } from '@vue/composition-api'
import { uniqueId } from 'lodash-es'

export default defineComponent({
  name: 'BaseChecklistSkeleton',
  setup() {
    const { loading } = inject('base-checklist')

    const optionItems = computed(() =>
      Array.from({ length: 5 }, () => {
        const value = Math.floor(Math.random() * 50)

        return 15 > value ? 15 : value
      })
    )

    return {
      uniqueId,

      loading,

      optionItems
    }
  }
})
</script>
